import { createContext } from 'react';

import { NetSuiteCustomers } from '@totem/components/orgManagement/orgDetails/netSuiteKeys/types';

interface Context {
  netSuiteCustomers: NetSuiteCustomers;
  searchTerm: string;
  page: number;
  pageSize: number;
  onRefresh: () => void;
  setSearchTerm: (searchTerm: string) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
}

export default createContext<Context>({
  netSuiteCustomers: [],
  searchTerm: '',
  page: 1,
  pageSize: 50,
  onRefresh: () => {},
  setSearchTerm: () => {},
  setPage: () => {},
  setPageSize: () => {},
});
